const KNOWN_OTP_ERRORS = [
  'INVALID_PHONE_NUMBER',
  'OTP_RESEND_TOO_SOON',
  'OTP_TOO_MANY_REQUESTS',
  'OTP_SEND_FAILED',
  'OTP_INVALID_CODE',
  'OTP_EXPIRED',
  'OTP_TOO_MANY_ATTEMPTS',
  'OTP_SESSION_EXPIRED',
  'PHONE_ALREADY_IN_USE',
  'PHONE_SHARED_USE_OTHER_LOGIN',
  'FIRST_NAME_REQUIRED',
  'INVALID_EMAIL',
  'EMAIL_ALREADY_REGISTERED',
];

/** Translation key (otp-error.*) for an error from the /user/otp or /user/phone endpoints; null = network error. */
export function otpErrorKey(error: any): string {
  const message = error?.error?.message;
  return 'otp-error.' + (KNOWN_OTP_ERRORS.includes(message) ? message : 'GENERIC');
}

/** "0:42" for a resend countdown in seconds. */
export function formatCountdown(seconds: number): string {
  const s = Math.max(0, Math.ceil(seconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}
